/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestEmailCredentialsFromJSON, FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestEmailCredentialsToJSON, } from './FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestEmailCredentials';
import { FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestExternalSocialIdentifierFromJSON, FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestExternalSocialIdentifierToJSON, } from './FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestExternalSocialIdentifier';
import { FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestAdditionalOptionsFromJSON, FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestAdditionalOptionsToJSON, } from './FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestAdditionalOptions';
import { FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestExternalInfoFromJSON, FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestExternalInfoToJSON, } from './FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestExternalInfo';
/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateWithExternalIdRequest interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdRequest(value) {
    return true;
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Locale': json['Locale'] == null ? undefined : json['Locale'],
        'RefreshToken': json['RefreshToken'] == null ? undefined : json['RefreshToken'],
        'SessionId': json['SessionId'] == null ? undefined : json['SessionId'],
        'EmailCredentials': json['EmailCredentials'] == null ? undefined : FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestEmailCredentialsFromJSON(json['EmailCredentials']),
        'ExternalSocialIdentifier': json['ExternalSocialIdentifier'] == null ? undefined : FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestExternalSocialIdentifierFromJSON(json['ExternalSocialIdentifier']),
        'ExternalInfo': json['ExternalInfo'] == null ? undefined : FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestExternalInfoFromJSON(json['ExternalInfo']),
        'AdditionalOptions': json['AdditionalOptions'] == null ? undefined : FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestAdditionalOptionsFromJSON(json['AdditionalOptions']),
    };
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Locale': value['Locale'],
        'RefreshToken': value['RefreshToken'],
        'SessionId': value['SessionId'],
        'EmailCredentials': FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestEmailCredentialsToJSON(value['EmailCredentials']),
        'ExternalSocialIdentifier': FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestExternalSocialIdentifierToJSON(value['ExternalSocialIdentifier']),
        'ExternalInfo': FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestExternalInfoToJSON(value['ExternalInfo']),
        'AdditionalOptions': FxIdWebFeaturesAuthAuthenticateWithExternalIdRequestAdditionalOptionsToJSON(value['AdditionalOptions']),
    };
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateWithExternalIdRequest.js.map